<template>
  <a-table
    rowKey="index"
    :dataSource="dataList"
    :columns="columns"
    :pagination="false"
    size="small"
    class="mb20 mt30"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'deal'">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          :checked="record.enabled === 0"
          @change="change(record)"
        />
      </template>
    </template>
  </a-table>
  <Pagination v-if="dataList && dataList.length > 0" />
</template>
<script>
import { toRefs, inject } from 'vue'
export default {
  setup() {
    const state = inject('state')

    return {
      ...toRefs(state),
      change(text) {
        text.enabled === 0 ? (text.enabled = 1) : (text.enabled = 0)
        state.updateSwitch(text)
      },
      columns: [
        {
          title: '语言英文',
          dataIndex: 'langEn',
          key: 'langEn',
          width: '25%'
        },
        {
          title: '语言中文',
          dataIndex: 'langCn',
          key: 'langCn',
          width: '25%'
        },
        {
          title: '语言简码',
          dataIndex: 'langCode',
          key: 'langCode',
          width: '25%'
        },
        {
          title: '是否启动多语言',
          key: 'deal',
          width: '25%'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
